import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { Button, SubscribeButton } from "@/components";
import { useUserDetails } from "@/hooks";
import { ChevronLeft } from "@/icons";
import { useTranslate, useUser } from "@/providers/context";
import { cn } from "@/utils";

import { UserAvatar } from "@/components/User/UserAvatar";
import { NotificationsDropdown } from "../Notifications";
interface HeaderProps {
  content?: ReactNode; // Override the back button, used on main tabs
  rightContent?: ReactNode; // To the left of the profile picture
  className?: string;
}

export const Header = ({ content, rightContent, className }: HeaderProps) => {
  const navigate = useNavigate();
  const { user_name, uid, userIsSubscribed } = useUser();
  const { data } = useUserDetails();
  const { translate } = useTranslate();

  return (
    <div
      className={cn([
        "flex h-[94px] w-full items-center justify-between",
        className,
      ])}
    >
      {content ? (
        <div className="overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {content}
        </div>
      ) : (
        <Button
          size="m"
          className="p2-semibold ml-[-4px]" // Make it flush with left aligned content
          variant="tertiary"
          icon={<ChevronLeft className="h-[20px] w-[20px]" />}
          iconPosition="left"
          onClick={() => navigate(-1)}
        >
          {translate("Back")}
        </Button>
      )}
      <div className="relative flex items-center">
        <div
          className="absolute -left-[60px] top-0 h-full w-[60px]"
          style={{
            background:
              "linear-gradient(270deg, #FFF 40%, rgba(255, 255, 255, 0.00) 100%)",
          }}
        />
        <div className="mr-3 flex items-center">{rightContent}</div>
        {}
        {uid ? (
          <div className="flex gap-3">
            <NotificationsDropdown />
            {!userIsSubscribed && <SubscribeButton />}
            <UserAvatar
              name={user_name ?? ""}
              imageUrl={data?.avatar_url}
              onClick={() => navigate("/profile")}
            />
          </div>
        ) : (
          <div className="hidden gap-[8px] sm:flex">
            <Button
              size="m"
              variant="tertiary"
              className="capitalize"
              onClick={() => navigate("/sign-in")}
            >
              {translate("Sign in")}
            </Button>
            <Button
              size="m"
              className="capitalize"
              onClick={() => navigate("/sign-up")}
            >
              {translate("Sign up")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
